import { dataHooks } from '../../../../../libs/dataHooks';

export const modalBoxDataHooks = dataHooks<{
  closeButton;
  content;
  video;
  image;
  viewerLink;
  editLink;
}>('modal-box');
